import { useTranslation } from "react-i18next";
import { TabContext, TabPanel } from "@mui/lab";
import { Box, Button, Grid, Stack, Tab, Typography } from "@mui/material";

import { Tabs } from "common/components/Tabs/Tabs";

export const ActorReviewClaim = (): JSX.Element => {
  const { t } = useTranslation();
  // TODO: replace values with values from Api when it is available
  const instructionsText =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla metus justo, accumsan vel turpis ac, vulputate suscipit dui. Quisque quis risus venenatis felis cursus mattis. Duis tortor diam, dictum eu viverra vitae, suscipit et risus. Sed in pellentesque erat, et auctor lectus. Ut dignissim tortor egestas nulla vulputate, in dapibus magna fermentum. Nulla varius elit non magna mollis sagittis. Nulla suscipit tellus non nisi tristique condimentum. Nunc et tellus in tellus semper sollicitudin quis eu velit. Etiam vitae venenatis nibh, quis molestie leo. Donec a tincidunt dui. Quisque commodo magna in fringilla maximus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Vestibulum turpis lacus, accumsan id magna vitae, malesuada feugiat ex. Aenean rutrum pharetra dolor, dapibus ultricies ex dapibus nec. Phasellus iaculis ante at sem accumsan dapibus. Sed ornare nulla vel tortor luctus pretium. Mauris et eros nec tortor feugiat malesuada faucibus ut lacus. In id tortor interdum, condimentum felis a, pellentesque orci. Vestibulum luctus egestas metus. Nunc vitae suscipit tellus. Cras dapibus enim eget nulla volutpat tristique. Maecenas non arcu nec erat sagittis aliquet ac ac lorem. Nunc interdum ornare pulvinar. Donec eu mi auctor, pharetra libero eu, eleifend lorem. Fusce id felis malesuada, ullamcorper neque sed, eleifend nunc. Nam tempus bibendum ex, vitae blandit libero venenatis at. Morbi in dapibus orci, at fermentum mauris. Nunc tincidunt mi ut gravida viverra. Nulla facilisi. Duis elementum, justo quis condimentum pharetra, metus erat varius lacus, nec blandit leo erat nec justo. Mauris vulputate diam ac mi hendrerit, at tempus tortor porta. Quisque tristique elit non dolor convallis elementum sit amet vel felis. Ut erat risus, eleifend eu ornare sit amet, euismod ut ipsum. Donec lobortis suscipit quam in pretium. Donec tristique odio vitae dolor viverra, egestas vehicula metus consectetur. Fusce tempor eget elit sit amet iaculis. Suspendisse lobortis cursus eros, eleifend porttitor tortor pulvinar ac. Integer venenatis rutrum lectus, et bibendum lacus elementum at. Nullam in euismod purus. Morbi convallis, lorem eu rhoncus venenatis, magna augue mattis est, sed congue erat ex nec tortor. Quisque non pharetra tellus, sit amet interdum turpis. Nunc eleifend turpis elementum ipsum rutrum feugiat. Duis auctor eu nulla vel fringilla. Nulla tincidunt posuere lorem sed bibendum.";
  const imageArray = [
    {
      url: "",
      status: "APPROVED",
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid item xs={9} sx={{ overflow: "auto", height: "100%" }}>
        <Grid container spacing={3} sx={{ pr: "2px", pb: 2 }}>
          {imageArray.map((image, index) => (
            <Grid key={index} item xs={10}></Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={3} sx={{ overflow: "hidden", height: "100%" }}>
        <Stack sx={{ maxHeight: "100%" }}>
          <TabContext value="Instructions">
            <Tabs>
              <Tab label={t("Instructions")} value="Instructions" />
            </Tabs>
            <TabPanel value="Instructions">
              <Box sx={{ overflow: "auto" }}>
                <Typography variant="body1" p={1}>
                  {instructionsText}
                </Typography>
              </Box>
            </TabPanel>
          </TabContext>
          <Stack spacing={2} paddingY={2}>
            <Button variant="contained" size="medium">
              {t("CompleteJob")}
            </Button>
            <Button size="medium">{t("UnclaimJob")}</Button>
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};
